<template>
  <div>
    <div class="text-sm font-bold uppercase text-gray-500">
      {{ title }}
    </div>
    <div class="mt-1">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'title-slot',
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>